// Caller list and per-caller open-item counts will come from GET /customers/:id/callers when the backend ships it. Until then the Callers page is search-first.

export type CallerRecord = {
  phone: string;
  name: string | null;
  last_call_date: string;
  call_count: number;
  memory_count: number;
};

export function normalizePhoneDigits(phone: string): string {
  const d = phone.replace(/\D/g, "");
  if (d.length === 11 && d.startsWith("1")) return d.slice(1);
  return d;
}
